import { render } from "./PilotOffersWidget.vue?vue&type=template&id=3921d5b2&scoped=true&ts=true"
import script from "./PilotOffersWidget.vue?vue&type=script&lang=ts"
export * from "./PilotOffersWidget.vue?vue&type=script&lang=ts"

import "./PilotOffersWidget.vue?vue&type=style&index=0&id=3921d5b2&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3921d5b2"]])

export default __exports__